import { PRODUCT_PACKAGES_URL } from "../../context/paths";

const authHeaders = (token) => ({
    "Content-Type": "application/json",
    "authorization": `Bearer ${token}`,
});

export const listProductPackages = async (token, { q, isActive } = {}) => {
    try {
        const params = new URLSearchParams();
        if (q) {
            params.set("q", q);
        }
        if (isActive !== undefined && isActive !== null) {
            params.set("isActive", String(isActive));
        }
        const query = params.toString();
        const url = query ? `${PRODUCT_PACKAGES_URL}?${query}` : PRODUCT_PACKAGES_URL;

        const response = await fetch(url, {
            method: "GET",
            headers: authHeaders(token),
        });
        return await response.json();
    } catch (error) {
        return {
            message: "Erro ao obter pacotes!",
            type: "error",
        };
    }
};

export const getProductPackage = async (token, id) => {
    try {
        const response = await fetch(`${PRODUCT_PACKAGES_URL}/${id}`, {
            method: "GET",
            headers: authHeaders(token),
        });
        return await response.json();
    } catch (error) {
        return {
            message: "Erro ao obter pacote!",
            type: "error",
        };
    }
};

export const createProductPackage = async (token, body) => {
    try {
        const response = await fetch(PRODUCT_PACKAGES_URL, {
            method: "POST",
            headers: authHeaders(token),
            body: JSON.stringify(body),
        });
        return await response.json();
    } catch (error) {
        return {
            message: "Erro ao cadastrar pacote!",
            type: "error",
        };
    }
};

export const updateProductPackage = async (token, id, body) => {
    try {
        const response = await fetch(`${PRODUCT_PACKAGES_URL}/${id}`, {
            method: "PUT",
            headers: authHeaders(token),
            body: JSON.stringify(body),
        });
        return await response.json();
    } catch (error) {
        return {
            message: "Erro ao atualizar pacote!",
            type: "error",
        };
    }
};

export const referenceQuote = async (token, body) => {
    try {
        const response = await fetch(`${PRODUCT_PACKAGES_URL}/reference-quote`, {
            method: "POST",
            headers: authHeaders(token),
            body: JSON.stringify(body),
        });
        return await response.json();
    } catch (error) {
        return {
            message: "Erro ao obter cotação de referência!",
            type: "error",
        };
    }
};

export const generatePackageCopy = async (token, body) => {
    try {
        const response = await fetch(`${PRODUCT_PACKAGES_URL}/generate-copy`, {
            method: "POST",
            headers: authHeaders(token),
            body: JSON.stringify(body),
        });
        const data = await response.json().catch(() => null);
        if (data && typeof data === "object") {
            return data;
        }
        return {
            message: response.ok
                ? "Resposta inválida ao gerar copy do pacote."
                : `Erro ao gerar copy do pacote (${response.status}).`,
            type: "error",
        };
    } catch (error) {
        return {
            message: "Erro ao gerar copy do pacote!",
            type: "error",
        };
    }
};

export const presignPackageImage = async (token, id, body) => {
    try {
        const response = await fetch(`${PRODUCT_PACKAGES_URL}/${id}/image/presign`, {
            method: "POST",
            headers: authHeaders(token),
            body: JSON.stringify(body),
        });
        return await response.json();
    } catch (error) {
        return {
            message: "Erro ao presignar imagem do pacote!",
            type: "error",
        };
    }
};

export const confirmPackageImage = async (token, id, body) => {
    try {
        const response = await fetch(`${PRODUCT_PACKAGES_URL}/${id}/image/confirm`, {
            method: "POST",
            headers: authHeaders(token),
            body: JSON.stringify(body),
        });
        return await response.json();
    } catch (error) {
        return {
            message: "Erro ao confirmar imagem do pacote!",
            type: "error",
        };
    }
};

export const deletePackageImage = async (token, id) => {
    try {
        const response = await fetch(`${PRODUCT_PACKAGES_URL}/${id}/image`, {
            method: "DELETE",
            headers: authHeaders(token),
        });
        return await response.json();
    } catch (error) {
        return {
            message: "Erro ao remover imagem do pacote!",
            type: "error",
        };
    }
};
